/* eslint-disable no-new */

import { Initializer } from '@frds/utilities/src/scripts/init/Initializer';
import { Collapse } from './index';

new Initializer('.${prefix}-collapse', [Collapse]);
